<template>
  <v-form ref="form">
    <FormPanels>
      <FormPanel label="Role Info">
        <FormRow required label="Role Title">
          <TextField placeholder="Role Title" v-model="form.name"></TextField>
        </FormRow>
      </FormPanel>
    </FormPanels>
    <SubmitFooter :refs="$refs" :submit="submit">
      {{ btnText }}

      <template v-if="action == 'edit'" #actions>
        <div>
          <v-btn
            @click="$emit('destroy')"
            outlined
            color="primary"
            elevation="0"
            rounded
            large
          >
            Delete Role
          </v-btn>
        </div>
      </template>
    </SubmitFooter>
  </v-form>
</template>

<script>
import mixin from "../../../_extends/form.extends.js";

export default {
  extends: mixin,
  props: {
    action: String,
  },
};
</script>

<style></style>
